import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { IBannerPopup } from 'src/app/core/models/tenancy.interface';

@Component({
  selector: 'app-reward-popup-dialog',
  standalone: true,
  imports: [MatDialogModule],
  templateUrl: './reward-popup-dialog.component.html',
  styleUrls: ['./reward-popup-dialog.component.scss']
})
export class RewardPopupDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<RewardPopupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IBannerPopup
  ) { }

  // Method to close the dialog
  cancel(): void {
    this.dialogRef.close();
  }
}
